import { useQuery } from '@tanstack/react-query';
import { walletDetails } from 'api';

export default function useWalletDetails() {
  const Request = useQuery({
    queryFn: ({ queryKey }) => walletDetails(queryKey[1] || {}),
    queryKey: ['walletDetails'],
    refetchOnMount: false,
    select: (data) => data?.data?.data || {},
  });

  return { ...Request };
}
